import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { MetricTypes } from '@spotify-internal/semantic-metrics';
import generatePkce from '../utils/generatePkce';
import generateRandomString from '../utils/generateRandomString';
import getAuthCodeViaIframe from './util/getAuthCodeViaIframe';
import handleAuthCodeError from './util/handleAuthCodeError';
import { defaultTags, MetricActions, sendMetric } from '../utils/metricsHelper';

var getAuthCodeInfo = function getAuthCodeInfo(clientConfig, authServerConfig) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var pkce, state, authorizeRequest, authCodeResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pkce = generatePkce();
            state = generateRandomString(32);
            authorizeRequest = {
              clientId: clientConfig.clientId,
              redirectUri: window.location.origin,
              scopes: clientConfig.scopes,
              codeChallenge: pkce.codeChallenge,
              state: state,
              responseMode: 'web_message',
              prompt: 'none',
              responseType: 'code'
            };
            _context.next = 5;
            return getAuthCodeViaIframe(authorizeRequest, authServerConfig);

          case 5:
            authCodeResult = _context.sent;

            if (!('error' in authCodeResult)) {
              _context.next = 9;
              break;
            }

            sendMetric({
              metric_type: MetricTypes.COUNTER,
              what: MetricActions.AUTH_CODE_ERROR,
              value: 1,
              tags: Object.assign({
                clientId: clientConfig.clientId,
                error: authCodeResult.error,
                serverUrl: authServerConfig.url
              }, defaultTags)
            });
            throw handleAuthCodeError(authCodeResult);

          case 9:
            return _context.abrupt("return", {
              code: authCodeResult.code,
              codeVerifier: pkce.codeVerifier,
              redirectUri: window.location.origin
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

export default getAuthCodeInfo;